import { useState, useEffect } from "react";
import TopHeader from "../../../Components/TopHeader";
import Prince from "../../../Components/Prince";
import { DateRangePicker } from "react-date-range";
import { format } from "date-fns";
import { MdDateRange } from "react-icons/md";
import FilterComponent from "../ReportComponent/FilterComponent";
import CardComponent from "../ReportComponent/CardComponent";
import { Link } from "react-router-dom";
import ExportButton from "../../../Components/ExportButton";

function LeadStatusReport() {
  const apiUrl = process.env.REACT_APP_URL;
  const Token = localStorage.getItem("_ux98c_v1");
  const [dateFilterModalOPen, setDateFilterModalOpen] = useState(false);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [headerCount, setHeaderCount] = useState("");
  const [leadSourceCount, setLeadSourceCount] = useState([]);
  const [totalLeadSourceCount, setTotalLeadSourceCount] = useState("");
  const [totalLeadStageCount, setTotalLeadStageCount] = useState("");
  const [totalLeadOppartunity, setTotalLeadOppartunity] = useState("");
  const [totalStatusCount, setTotalStatusCount] = useState("");
  const [leadStageCount, setLeadStageCount] = useState([]);

  const [leadSourceOptions, setLeadSourceOptions] = useState([]);
  const [employeeId, setEmployeeId] = useState([]);
  const [state, setStates] = useState([]);
  const [leadStatus, setLeadStatus] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [leadStatusReport, setLeadStatusReport] = useState([]);
  const [leadOpportunityExcel, setLeadOpportunityExcel] = useState([]);

  const onFilterChange = (data) => {
    setFilterData(data);
    // console.log(data);
  };

  const [date, setDate] = useState(null);

  const handleDateFilterClick = () => {
    setDateFilterModalOpen(true);
  };
  const handleCloseDateFilterModal = () => {
    setDateFilterModalOpen(false);
  };

  const handleDateChange1 = (ranges) => {
    const adjustedStartDate = new Date(ranges.selection.startDate);
    adjustedStartDate.setUTCDate(adjustedStartDate.getUTCDate() + 1); // Subtract one day
    adjustedStartDate.setUTCHours(0, 0, 0, 0); // Set time to 00:00:00 UTC

    const adjustedEndDate = new Date(ranges.selection.endDate);
    adjustedEndDate.setUTCDate(adjustedEndDate.getUTCDate() + 1); // Add one day
    adjustedEndDate.setUTCHours(0, 0, 0, 0); // Set time to 00:00:00 UTC

    setFrom(adjustedStartDate.toISOString()); // Convert to UTC string format
    setTo(adjustedEndDate.toISOString());
    setDate(ranges.selection);

    if (
      ranges.selection.startDate &&
      ranges.selection.endDate &&
      ranges.selection.startDate.getTime() !==
        ranges.selection.endDate.getTime()
    ) {
      handleCloseDateFilterModal(); // close modal
    }
  };

  useEffect(() => {
    const fetchApi = async () => {
      try {
        const response = await fetch(`${apiUrl}/stageReport/headerCount`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        });
        const data = await response.json();
        setHeaderCount(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchApi();
  }, []);

  const fetchApi1 = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/stageReport/leadSourceCount?from=${from}&to=${to}&leadSource=${
          filterData.filterByLeadSource || ""
        }&employeeId=${filterData.filterByLeadPipeline || ""}&status=${
          filterData.filterByBusinessCategory || ""
        }&state=${filterData.filterByPartner || ""}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      const data = await response.json();
      setLeadSourceCount(data.data);
      setTotalLeadSourceCount(data.totalCount);
      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };
  // fetchApi1();
  // }, []);

  // useEffect(() => {
  const fetchApi2 = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/stageReport/leadStageCount?from=${from}&to=${to}&leadSource=${
          filterData.filterByLeadSource || ""
        }&employeeId=${filterData.filterByLeadPipeline || ""}&status=${
          filterData.filterByBusinessCategory || ""
        }&state=${filterData.filterByPartner || ""}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      const data = await response.json();
      console.log(data);
      setLeadStageCount(data.data.formattedData);
      setTotalLeadStageCount(data.totalCount);
    } catch (error) {
      console.log(error);
    }
  };
  //  console.log(leadStageCount);
  //fetchApi2();
  // }, []);

  useEffect(() => {
    fetchApi1();
    fetchApi2();
  }, []);

  const handleApplyFilter = () => {
    fetchApi1();
    fetchApi2();
  };

  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/1`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setLeadSourceOptions(data.data);
        }
      });

    fetch(`${apiUrl}/employee/allStates/101`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setStates(data.data);
        }
      })
      .catch((error) => {
        // console.error("Error fetching gender options:", error);
      });
  }, []);

  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/8`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setLeadStatus(data.data);
        }
      });
  }, []);

  useEffect(() => {
    fetch(`${apiUrl}/employee/empDropdownSub`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setEmployeeId(data.data);
        }
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    fetch(`${apiUrl}/stageReport/leadStatusCount`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data && Array.isArray(data.data.leadStatusCount)) {
          setLeadStatusReport(data.data.leadStatusCount);
          setTotalStatusCount(data.totalCount);
        }
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    fetch(`${apiUrl}/stageReport/leadOpportunity`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data && Array.isArray(data.data.formattedData)) {
          setLeadOpportunityExcel(data.data.formattedData);
          setTotalLeadOppartunity(data.totalCount);
        }
      })
      .catch((error) => {});
  }, []);

  //console.log(leadStatusReport);
  return (
    <>
      <div className="page">
        <TopHeader />
        <Prince />
        <div className="main-content side-content pt-0 m-0">
          <div className="main-container container-fluid">
            <div className="inner-body">
              <div className="page-header my-2">
                <div>
                  <h2 className="main-content-title tx-24 mb-0 mt-1 ">
                    Lead Status Report
                  </h2>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a>Report</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Lead Status Report
                    </li>
                  </ol>
                </div>
              </div>
              <div style={{ marginTop: "15px" }}>
                <div className="row">
                  <CardComponent
                    title={"Lead Generated  2024"}
                    link={"Total Lead Generated 2024"}
                    count={headerCount.totalLeadThisYear}
                  />
                  <CardComponent
                    title={"Lead Generated Q1 2024"}
                    link={"Total Lead Generated Q1 2024"}
                    count={headerCount.totalLeadThisQ1Year}
                  />
                  <CardComponent
                    title={"Lead Generated Q2 2024"}
                    link={"Total Lead Generated Q2 2024"}
                    count={headerCount.totalLeadThisQ2Year}
                  />
                  <CardComponent
                    title={"Lead Generated Q3 2024"}
                    link={"Total Lead Generated Q3 2024"}
                    count={headerCount.totalLeadThisQ3Year}
                  />
                  <CardComponent
                    title={"Total Won Lead Yearly"}
                    link={"Won Lead Yearly"}
                    count={headerCount.wonLeadCount}
                  />
                  <div className="card custom-card">
                    <div className="card-body py-0 pb-3">
                      <div className="row">
                        <div className="col-sm-2 mt-3">
                          <label>Date Filter</label>
                          <div>
                            <button
                              className="calender btn btn-outline-danger"
                              onClick={handleDateFilterClick}
                              style={{
                                fontSize: "11px",
                                // width: "215px",
                              }}
                            >
                              <MdDateRange
                                size={16}
                                style={{ display: "inline" }}
                              />{" "}
                              {date
                                ? `${format(
                                    date.startDate,
                                    "MMM dd yyyy"
                                  )} -- ${format(date.endDate, "MMM dd yyyy")}`
                                : "Select Calender Date"}
                            </button>
                          </div>
                          <div
                            className={`modal ${
                              dateFilterModalOPen ? "show" : ""
                            } bg-black-7`}
                            style={{
                              display: dateFilterModalOPen ? "block" : "none",
                            }}
                            tabIndex="-1"
                            role="dialog"
                          >
                            <div
                              className=" modal-dialog modal-dialog modal-lg"
                              role="document"
                              style={{ marginTop: "80px" }}
                            >
                              <div
                                className="modal-content"
                                style={{ borderRadius: "8px" }}
                              >
                                <div className="modal-header">
                                  <h5 className="modal-title">
                                    Select Date Range
                                  </h5>
                                  <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={handleCloseDateFilterModal}
                                  >
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div
                                  className="modal-body"
                                  style={{ width: "100%" }}
                                >
                                  <DateRangePicker
                                    // ranges={[date]}
                                    ranges={
                                      date
                                        ? [date]
                                        : [
                                            {
                                              startDate: new Date(),
                                              endDate: new Date(),
                                              key: "selection",
                                            },
                                          ]
                                    }
                                    onChange={handleDateChange1}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <FilterComponent
                          leadSourceOptions={leadSourceOptions}
                          //  leadPipelineOptions={employees}
                          leadStatus={leadStatus}
                          partnerOptions={state}
                          employeeId={employeeId}
                          onFilterChange={onFilterChange}
                        />
                        <div className="d-flex">
                          <div className="mr-2">
                            <button
                              style={{ marginTop: "30px" }}
                              className="btn btn-outline-success"
                              onClick={handleApplyFilter}
                            >
                              Apply Filter
                            </button>
                          </div>
                          <div className="mx-2">
                            <button
                              style={{ marginTop: "30px" }}
                              className="btn btn-outline-warning"
                              onClick={() => {
                                setDate({
                                  startDate: new Date(),
                                  endDate: new Date(),
                                  key: "selection",
                                });
                                window.location.reload();
                              }}
                            >
                              Clear Filter
                            </button>
                          </div>
                        </div>
                      </div>{" "}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card custom-card">
                      <div className="card-body">
                        <h5 style={{ textDecoration: "underline" }}>
                          Lead Source
                        </h5>

                        <div class="table-responsive">
                          <table class="table table-hover table-nowrap">
                            <thead class="table-light">
                              <tr>
                                <th scope="col">Source</th>
                                <th scope="col">Lead Generated</th>
                                <th scope="col">Percentage</th>
                                {/* <th scope="col">Rate</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {leadSourceCount.map((item, index) => (
                                <tr>
                                  <td data-label="Email" key={index}>
                                    <span>{item.leadSource}</span>
                                  </td>
                                  <td data-label="Phone">
                                    <Link
                                      // to={"/leads/Open"}
                                      class="text-current"
                                      state={{ leadSource: item.leadSource }}
                                      //href="mailto:robert.fox@example.com"
                                    >
                                      {item.count}
                                    </Link>
                                  </td>
                                  <td data-label="Phone1">
                                    <span>{item.percentage} %</span>
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td data-label="Email">
                                  <span>
                                    <strong>Total</strong>
                                  </span>
                                </td>
                                <td data-label="Phone">
                                  <strong>{totalLeadSourceCount}</strong>
                                </td>
                                <td data-label="Phone1">
                                  <span>
                                    <strong>{100} %</strong>
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="mt-2"
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          <ExportButton
                            reportUrl={`${apiUrl}/stageReport/leadSourceCountExcel`}
                            filterState={filterData}
                            fileName="OpenLeads_Jan.csv"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card custom-card">
                      <div className="card-body">
                        <h5 style={{ textDecoration: "underline" }}>
                          Lead Stage
                        </h5>
                        <div class="table-responsive">
                          <table class="table table-hover table-nowrap">
                            <thead class="table-light">
                              <tr>
                                <th scope="col">Lead Stage</th>
                                {/* <th scope="col">Total Leads</th> */}
                                <th scope="col">Number of Leads</th>
                                <th scope="col">Percentage</th>
                              </tr>
                            </thead>
                            <tbody>
                              {leadStageCount.map((item, index) => (
                                <tr key={index}>
                                  <td data-label="Email">
                                    <span>{item.stage}</span>
                                  </td>

                                  <td data-label="Phone">
                                    <span>{item.count}</span>
                                  </td>
                                  <td data-label="Phone">
                                    <span>{item.per}</span>
                                  </td>

                                  {/*  */}
                                </tr>
                              ))}
                              <tr>
                                <td data-label="Email">
                                  <span>
                                    <strong>Total</strong>
                                  </span>
                                </td>
                                <td data-label="Phone">
                                  <strong>{totalLeadStageCount}</strong>
                                </td>
                                <td data-label="Phone1">
                                  <span>
                                    <strong>{100} %</strong>
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div
                          className="mt-2"
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          <ExportButton
                            reportUrl={`${apiUrl}/stageReport/leadStageCountExcel`}
                            filterState={filterData}
                            fileName="OpenLeads_Jan.csv"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="card custom-card">
                      <div className="card-body">
                        <h5 style={{ textDecoration: "underline" }}>
                          Lead to Opportunity
                        </h5>
                        <div class="table-responsive">
                          <table class="table table-hover table-nowrap">
                            <thead class="table-light">
                              <tr>
                                <th scope="col">Metric</th>
                                {/* <th scope="col">Total Count</th> */}
                                <th scope="col">Count</th>
                                <th scope="col">Percentage</th>
                              </tr>
                            </thead>
                            <tbody>
                              {leadOpportunityExcel?.map((item, index) => (
                                <tr key={index}>
                                  <td data-label="Email">
                                    <span>{item.status}</span>
                                  </td>
                                  {/* <td data-label="Email">
                                    <span>{item.totalCount}</span>
                                  </td> */}
                                  <td data-label="Phone">
                                    <Link
                                      // to={"/leads/Open"}
                                      class="text-current"
                                      state={{ stage: item.status }}
                                    >
                                      {item.count}
                                    </Link>
                                  </td>
                                  <td data-label="Email">
                                    <span>{item.per}</span>
                                  </td>

                                  {/*  */}
                                </tr>
                              ))}
                              <tr>
                                <td data-label="Email">
                                  <span>
                                    <strong>Total</strong>
                                  </span>
                                </td>
                                <td data-label="Phone">
                                  <strong>{totalLeadOppartunity}</strong>
                                </td>
                                <td data-label="Phone1">
                                  <span>
                                    <strong>{100} %</strong>
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="mt-2"
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          <ExportButton
                            reportUrl={`${apiUrl}/stageReport/leadOpportunityExcel`}
                            filterState={filterData}
                            fileName="OpenLeads_Jan.csv"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="card custom-card"></div>
                    <div className="card custom-card">
                      <div className="card-body">
                        <h5 style={{ textDecoration: "underline" }}>
                          Lead Status Report
                        </h5>
                        <div class="table-responsive">
                          <table class="table table-hover table-nowrap">
                            <thead class="table-light">
                              <tr>
                                <th scope="col">Metric</th>
                                {/* <th scope="col">Total Count</th> */}
                                <th scope="col">Count</th>
                                <th scope="col">Percentage</th>
                                {/* <th scope="col">Percentage of Total Leads</th> */}
                                {/* <th scope="col">Rate</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {leadStatusReport?.map((item, index) => (
                                <tr key={index}>
                                  <td data-label="Email">
                                    <span>{item?.status}</span>
                                  </td>
                                  {/* <td data-label="Email">
                                    <span>{item?.totalCount}</span>
                                  </td> */}
                                  <td data-label="Phone">
                                    <a
                                      class="text-current"
                                      // href="mailto:robert.fox@example.com"
                                    >
                                      {item.count}
                                    </a>
                                  </td>
                                  <td data-label="Email">
                                    <span>{item?.per}</span>
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td data-label="Email">
                                  <span>
                                    <strong>Total</strong>
                                  </span>
                                </td>
                                <td data-label="Phone">
                                  <strong>{totalStatusCount}</strong>
                                </td>
                                <td data-label="Phone1">
                                  <span>
                                    <strong>{100} %</strong>
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="mt-2"
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          <ExportButton
                            reportUrl={`${apiUrl}/stageReport/leadStatusCountExcel`}
                            filterState={filterData}
                            fileName="OpenLeads_Jan.csv"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Row */}
              </div>

              {}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LeadStatusReport;
